import { faDollarSign } from '@fortawesome/pro-solid-svg-icons/faDollarSign';
import { faEuroSign } from '@fortawesome/pro-solid-svg-icons/faEuroSign';
import { faSterlingSign } from '@fortawesome/pro-solid-svg-icons/faSterlingSign';

export const JPY = 'JPY';
export const USD = 'USD';
export const Unknown = 'Unknown';
export const CAD = 'CAD';
export const GBP = 'GBP';
export const AUD = 'AUD';
export const NZD = 'NZD';
export const EUR = 'EUR';

export const CurrencyCodeMapToIcon = {
  [USD]: faDollarSign,
  [EUR]: faEuroSign,
  [GBP]: faSterlingSign,
};

export const getCurrencyIcon = (code = USD) => CurrencyCodeMapToIcon[code] || CurrencyCodeMapToIcon[USD];
